import factory from './icon';
import Svg from './glyphs/delete.svg';

export default factory(Svg);
